import http from 'src/api/http';
import CommonRepository from 'src/api/repositories/common/common.repository';
import { IQueryResult } from 'src/api/types';

export default class CurrentTimeRepository extends CommonRepository {
  private static readonly baseRoute = '/currenttime';
  private static readonly apiURL = CurrentTimeRepository.setBaseUrl(this.baseURL, this.baseRoute);

  public get = async (): Promise<{ dateTime: string; apiVersion: string }> => {
    try {
      const { data, headers } = await http.get<IQueryResult<string>>(CurrentTimeRepository.apiURL);
      return {
        dateTime: data.item,
        apiVersion: headers['api-version'],
      };
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
